export default "__VITE_ASSET__CQidQWsQ__"